import { Table, Input } from "antd";
import React from "react";
import { formatNumber, unformatNumber } from "../../../../../utils/utilities";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import { setValueBilling } from "../../../../../redux/ducks/EditableTable";

const BillingPlanInput = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  const getCustomForm = useSelector((state) => get(state.EditableTableDuck, "customFormBilling", []));
  const getValueForm = (amount, month) => {
    let valueForm = amount;
    getCustomForm.forEach((a) => {
      if (a.month === month) {
        valueForm = a.amount;
      }
    });
    return valueForm;
  };

  const getDisplayTipe = (propsType, isOnlyVisual) => {
    if (
      (propsType === "kick-off" && userInfo.canEditKickOff && !isOnlyVisual) ||
      (propsType !== "kick-off" && userInfo.canEditCostEstimation && !isOnlyVisual)
    ) {
      return "input";
    } else {
      return "text";
    }
  };
  const columns = [
    {
      title: "",
      width: 200 + 48, // 48 is the width of the summary table cell with the plus icon,
      fixed: "left",
      render: () => t("projectEstimate.detail.tabs.kickOff.billingPlan"),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
      dataIndex: ["columnValueMap", "AP"],
      width: 100,
      fixed: "left",
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
      dataIndex: ["columnValueMap", "JANUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "JANUARY",
          value: getValueForm(amount, 1),
          lang: currentLanguage,
          id: "JANUARY",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 1),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
      dataIndex: ["columnValueMap", "FEBRUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "FEBRUARY",
          value: getValueForm(amount, 2),
          lang: currentLanguage,
          id: "FEBRUARY",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 2),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
      dataIndex: ["columnValueMap", "MARCH"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "MARCH",
          value: getValueForm(amount, 3),
          lang: currentLanguage,
          id: "MARCH",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 3),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
      dataIndex: ["columnValueMap", "APRIL"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "APRIL",
          value: getValueForm(amount, 4),
          lang: currentLanguage,
          id: "APRIL",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 4),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
      dataIndex: ["columnValueMap", "MAY"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "MAY",
          value: getValueForm(amount, 5),
          lang: currentLanguage,
          id: "MAY",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 5),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
      dataIndex: ["columnValueMap", "JUNE"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "JUNE",
          value: getValueForm(amount, 6),
          lang: currentLanguage,
          id: "JUNE",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 6),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
      dataIndex: ["columnValueMap", "JULY"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "JULY",
          value: getValueForm(amount, 7),
          lang: currentLanguage,
          id: "JULY",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 7),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
      dataIndex: ["columnValueMap", "AUGUST"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "AUGUST",
          value: getValueForm(amount, 8),
          lang: currentLanguage,
          id: "AUGUST",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 8),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
      dataIndex: ["columnValueMap", "SEPTEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "SEPTEMBER",
          value: getValueForm(amount, 9),
          lang: currentLanguage,
          id: "SEPTEMBER",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 9),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
      dataIndex: ["columnValueMap", "OCTOBER"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "OCTOBER",
          value: getValueForm(amount, 10),
          lang: currentLanguage,
          id: "OCTOBER",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 10),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
      dataIndex: ["columnValueMap", "NOVEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "NOVEMBER",
          value: getValueForm(amount, 11),
          lang: currentLanguage,
          id: "NOVEMBER",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 11),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
      dataIndex: ["columnValueMap", "DECEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount, record) => {
        const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
        return formatNumber({
          name: "DECEMBER",
          value: getValueForm(amount, 12),
          lang: currentLanguage,
          id: "DECEMBER",
          displayType,
          decimalScale: displayType === "input" ? 2 : 0,
          suffix: "EUR",
          customInput: Input,
          onChange: (e) => handleChange(e, 12),
        });
      },
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
      dataIndex: ["columnValueMap", "AS"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
      dataIndex: ["columnValueMap", "TOT"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
  ];
  const handleChange = (e, month) => {
    getCustomForm.forEach((f, i) => {
      if (f.month === month) {
        dispatch(setValueBilling(unformatNumber(e.target.value, currentLanguage), month, i));
      }
    });
  };
  return (
    <>
      <Table
        bordered
        dataSource={props.dataContentBillingPlan}
        columns={columns}
        size="small"
        pagination={false}
        scroll={{ x: 1500 }}
        rowClassName="table-primary"
      />
    </>
  );
};

export default BillingPlanInput;
